/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{padding:.1rem 1rem;margin-bottom:.1rem}.alert-secondary[_ngcontent-%COMP%]{color:#0b5f91}.alert-secondary-light[_ngcontent-%COMP%]{background-color:#eee}"];
export { styles as styles };
